import cx from 'classnames'

import { useAuth } from 'hooks/UseAuth'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import RightPanelContent from '../RightPanelContent/RightPanelContent'
import ProgressBar from '../ProgressBar/ProgressBar'
import { ProductTourCard } from '../LinkCards/ProductTourCard'
import { HelpCenterCard } from '../LinkCards/HelpCenterCard'
import Shared from '../../Shared.module.scss'
import Styles from './DemoScheduled.module.scss'

interface Props {
  transitionPage: (page: string) => void
  totalSteps: number
}

export const DemoScheduled = ({ transitionPage, totalSteps }: Props) => {
  const auth = useAuth()
  const workspace = useCurrentWorkspace()

  const { isTabletPortrait } = useResponsiveDesign()

  if (!auth) transitionPage('START_OVER')
  if (!workspace) transitionPage('CREATE_WORKSPACE')

  return (
    <div className={Shared.content}>
      <div className={Shared.leftPanel}>
        <div className={Shared.header}>
          <ProgressBar totalSteps={totalSteps} currentStep={totalSteps - 1} />
        </div>
        <div className={cx(Shared.largerLeftContent, Styles.largerLeftContent)}>
          <div className={Shared.title}>Your personalized onboarding is scheduled!</div>
          <div className={cx(Styles.subTitle, Shared.subTitle)}>
            Sit back and relax - You’ll find next steps in your email.
          </div>
          <div className={Styles.contents}>
            <HelpCenterCard />
            <ProductTourCard />
          </div>
        </div>
      </div>
      {!isTabletPortrait && <RightPanelContent screen="demoScheduled" />}
    </div>
  )
}
